import React, { Component } from 'react';
import { Form, Popover, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import util from '@util/index';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    return [
      {
        title: '客户',
        dataIndex: 'custom',
        key: 'custom',
        render: (text, record) => (
          <span>
            {record.custom}
            {record.projectName ? `(${record.projectName})` : ''}
          </span>
        ),
      },
      {
        title: '付款公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '退款金额',
        dataIndex: 'price',
        key: 'price',
        render: (text, record) => <span>{text ? util.numberFormat(record.price) : ''}</span>,
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '当前环节',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.name || ''}</span>;
        },
      },
      {
        title: '当前处理人',
        dataIndex: 'processorName',
        key: 'processorName',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.processorName || ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          let element;
          if (instance.status === 1) {
            element = <span style={{ color: 'red' }}>已完成</span>;
          } else {
            element = record.instance ? <span>处理中</span> : <span>待编辑</span>;
          }
          return element;
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return <Link to={`/incubator/refund_manage/open/${record.uuid}`}>查看</Link>;
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        onChange={this.handleChange}
        loading={loading}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/refund/TableBack.js